import "../styles/base.css";
import "../styles/mono-overrides.css";

import { MonoBackground } from "./components/MonoBackground";
import { Hero } from "./components/Hero";
import { SiteFooter } from "./components/SiteFooter";
import { LegalPage } from "./components/LegalPage";

export function App() {
  const path = typeof window === "undefined" ? "/" : window.location.pathname;
  const page =
    path === "/privacy" ? <LegalPage kind="privacy" /> :
    path === "/terms" ? <LegalPage kind="terms" /> :
    <Hero />;

  return (
    <section className="dark:text-orange-75 flex min-h-svh flex-col text-stone-800">
      <MonoBackground />
      {page}
      <SiteFooter />
    </section>
  );
}

export default App;
